const query = document.querySelector.bind(document);
const queryAll = document.querySelectorAll.bind(document);
const fromId = document.getElementById.bind(document);
const fromClass = document.getElementsByClassName.bind(document);
const fromTag = document.getElementsByTagName.bind(document);

const isInViewport = (el , partial) => {

    const rect = el.getBoundingClientRect();
    const elemTop = rect.top;
    const elemBottom = rect.bottom;

    if( partial )
        return ( elemTop < window.innerHeight && elemBottom >= 0 );
    else
        return ((elemTop >= 0) && (elemBottom <= window.innerHeight));
}



export { query, queryAll , fromId , fromClass , fromTag , isInViewport };
